<template>
  <div
    v-if="componentsShow"
    :id="data.id"
    class="zeus-component"
    :style="getCompStyles(data)"
    :is-editing="false"
    @click.passive="click"
  >
    <component
      :is="data.type"
      ref="cpt"
      :editable-data="data"
      :is-flow="isFlow"
      :page-id="pageId"
      @dispatchEvent="dispatchEvent"
      @hook:mounted="getDom"
      @hook:beforeDestroy="beforeDestroy"
    />
  </div>
</template>

    <script>
    import { renderBg } from './../utils/tools'
    import { BsGetCid, BsUtil } from 'dida-web-common'

    export default {
      props: {
        data: { type: Object },
        page: { type: Object },
        isFixedParent: { type: Boolean },
        siteData: {
          type: Object,
          default: () => ({})
        }
      },
      data() {
        return {
          $animations: [],
          childLoad: false,
          headerList: [],
          oneventList: [],
          eventKey: [],
          componentsShow: this.data.show,
          click: () => {},
          activeErrorTip: {}
        }
      },
      computed: {
        pageId() {
          // const pos = this.page?.options?.basic?.ACTPOS?.position
          const pos = this.data?.basic?.ACTPOS?.position || this.page?.options?.basic?.ACTPOS?.position
          return pos ? `_${pos}` : ''
        },
        layoutType() {
          return this.page?.options?.basic?.layoutType
        },
        isFixed() {
          return this.layoutType === 'fixed'
        },
        isFlow() {
          return this.layoutType === 'static'
        }
      },
      inject: ['globalConfig'],
      mounted() {
        this.initEvent()
        this.click = this.handlerClick()
        this.$nextTick(() => {
          if (this.$refs.cpt) {
            this.initAnimation()
          } else {
            this.watchComponent()
          }
        })
      },
      methods: {
        // 获取组件 DOM 挂载后的处理逻辑
        getDom() {
          while (this.headerList.length > 0) {
            const ev = this.headerList.pop()
            this.emitall(ev, this.$root.emitList[ev])
          }
          while (this.oneventList.length > 0) {
            const { handler, action, params, triggerParams, subscribe } = this.oneventList.pop()
            handler(action, triggerParams, params, subscribe)
          }
        },
        // 获取组件样式
        getCompStyles({ style, basic: cBase = {}}) {
          const {
            border = {},
            padding = {},
            margin = {},
            rect = {},
            shadow = {},
            background = {}
          } = style
          const unsetHeight = !this.globalConfig.editing && this.isFlow
          const { posl = 0, post = 0 } = rect
          return {
            position: this.isFlow ? 'static' : (this.isFixedParent ? 'fixed' : 'absolute'),
            width: this.isFlow ? `${this.getFlowWidth(margin)}${this.globalConfig.unit}` : this.handlerUnit(rect.w),
            height: unsetHeight ? 'auto' : this.handlerUnit(rect.h, rect.fs),
            border: `${this.handlerUnit(border.width)} ${border.style} ${border.color}`,
            borderRadius: this.getAngleVal(border.radius),
            overflow: cBase._overflow || 'hidden',
            padding: this.getAngleVal(padding),
            margin: this.getAngleVal((post || posl) ? { top: post, right: 0, bottom: 0, left: posl } : margin),
            boxShadow: `${this.handlerUnit(shadow.x)} ${this.handlerUnit(shadow.y)} ${this.handlerUnit(shadow.blur)} ${this.handlerUnit(shadow.spread)} ${shadow.color} ${shadow.inset === 'outset' ? '' : 'inset'}`,
            ...renderBg(background, this.$root.isSuWebp),
            ...this.getCoordinate(rect),
            opacity: rect.a,
            transform: this.setTransform(cBase),
            pointerEvents: cBase.pointerEvents ? 'none' : 'auto'
          }
        },
        setTransform(cBase) {
            const rotate = cBase.transform ? `rotate(${cBase.transform}deg)` : ''
           return this.data.pos === 'center' ? `translate(-50%, -50%) ${rotate}` : rotate
        },
        // 处理单位转换
        handlerUnit(v = 0, fs = false) {
          if (fs) {
            return '100%'
          }
          return isNaN(Number(v)) ? v : `${v}${this.globalConfig.unit}`
        },
        // 获取流式布局宽度
        getFlowWidth(margin) {
          return (this.$root.DATA.options.style?.rect?.width || 5) - (margin.left || 0) - (margin.right || 0)
        },
        // 获取角度值
        getAngleVal({ top = 0, right = 0, bottom = 0, left = 0 } = {}) {
          return `${this.handlerUnit(top)} ${this.handlerUnit(right)} ${this.handlerUnit(bottom)} ${this.handlerUnit(left)}`
        },
        // 计算组件距离页面顶部的高度
        // getComHeight(rem) {
        //     const fSize = isMobile() ? document.documentElement.clientWidth / 5 : 75 // 计算html的fontsize
        //     return (document.documentElement.clientHeight - rem * fSize) / 2 + 'px'
        // },
        // 获取坐标值
        getCoordinate(rect) {
          if (!this.isFixed) {
            return { left: this.handlerUnit(rect.x), top: this.handlerUnit(rect.y) }
          }
          if (this.data.pos === 'center') {
            return {
                left: '50%',
                top: '50%'
            }
         }
          return {
            left: this.getLocation(rect.l),
            right: this.getLocation(rect.r),
            top: this.getLocation(rect.t),
            bottom: this.getLocation(rect.b)
          }
        },
        // 获取位置值
        getLocation(v) {
          return v === undefined ? 'auto' : this.handlerUnit(v)
        },
        // 处理点击防抖
        handlerClick() {
          let oldtime = Date.now()
          let flag = true
          return () => {
            const newtime = Date.now()
            if (newtime - oldtime >= 500) {
              oldtime = Date.now()
              flag = true
            }
            if (flag) {
              this.clickText()
              flag = false
            }
          }
        },
        // 处理点击事件逻辑
        async clickText() {
          this.addClickStat()
          if (['mars-text', 'mars-image'].includes(this.data.type)) {
            const goLogin = this.data.basic?.goLogin
            if (goLogin === 1) {
              return this.dispatchEvent('$e_click')
            }
            const { cid, access_token } = await BsGetCid()
            if (!cid || !access_token) {
              if (goLogin === 2) {
                return this.$Login()
              } else if (goLogin === 3) {
                this.$Login()
                const cb = () => {
                  this.dispatchEvent('$e_click')
                  this.$bus.$off('logined', cb)
                }
                this.$bus.$on('logined', cb)
                return
              } else if (goLogin === 4) {
                this.$Login(() => {
                  location.reload()
                })
              }
            } else {
              return this.dispatchEvent('$e_click')
            }
          } else {
            return this.dispatchEvent('$e_click')
          }
        },
        // 判断是否为对象
        isObject() {
          try {
            return typeof JSON.parse(this.data.basic.COLOGID) === 'object'
          } catch (error) {
            return false
          }
        },
        // 分发活动事件
        dispatchActiveEvent(id, activeCode) {
          const errorTip = {
            ACTIVITY_IS_NOT_START: 'activityNotStartEvent',
            ACTIVITY_IS_INIT: 'activityNotStartEvent',
            ACTIVITY_RISK_ERROR: 'userProhibitEvent',
            ACTIVITY_ERROR: 'userProhibitEvent',
            ACTIVITY_USER_IDENTITY_ERROR: 'userNoMatchEvent',
            USER_CANNOT_BUY: 'userNoMatchEvent',
            ACTIVITY_IS_END: 'activityNotOnlineEvent',
            ACTIVITY_IS_NOT_ONLINE: 'activityNotOnlineEvent',
            ACTIVITY_LOSE_EFFICACY: 'activityNotOnlineEvent',
            ActivityNotReturned: 'activityNotReturned',
            ACTIVITY_USER_LABEL_ERROR: 'activityUserLabelError'
          }
          this.activeErrorTip = errorTip
          if (activeCode && errorTip[activeCode]) {
            const evid = id + errorTip[activeCode]
            if (this.$refs.cpt) {
              this.emitall(evid)
            } else {
              this.headerList.push(evid)
            }
          }
        },
        // 添加点击统计
        addClickStat(ev) {
          if (this.isObject()) {
            const obj = JSON.parse(this.data.basic.COLOGID)
            this.$track.addStat(`${obj.actions}_ck`, obj.params)
          } else {
            this.$track.addStat(`${this.data.basic.COLOGID}_ck`)
          }
        },
        // 分发事件
        dispatchEvent(ev, activeCode) {
          if (ev === 'active') {
            return this.dispatchActiveEvent(`${this.data.id}-`, activeCode)
          }
          const evid = `${this.data.id}-${ev}`
          if (this.$refs.cpt) {
            this.emitall(evid)
          } else {
            this.headerList.push(evid)
          }
        },
        // 触发事件
        emitall(evId, cpt) {
          cpt = cpt || { ctx: this.$refs.cpt }
          this.$bus.$emit(evId, cpt)
          let router = this.$root.DATA.routerList[evId]
          if (router && router !== this.$route.path && location.pathname.indexOf(this.$root.productName) > -1) {
            router = location.pathname.indexOf('web-local-dynamics') > -1 ? `/${this.$root.productName}${router}` : router
            if (router.indexOf('-replace') > -1 || router === '/') {
              this.$router.replace({ path: router, query: { ...(this.$route.query || {}) }})
            } else {
              this.$router.push({ path: router, query: { ...(this.$route.query || {}) }})
            }
          }
          if (evId.indexOf('$e_click') === -1) {
            this.$root.emitList[evId] = cpt
            if (!this.eventKey.includes(evId)) {
              this.eventKey.push(evId)
            }
          }
        },
        // 组件销毁前的处理逻辑
        beforeDestroy() {
          const tip = JSON.stringify(this.activeErrorTip)
          this.eventKey.forEach(evId => {
            if (evId.indexOf('noDestroy') === -1 && tip.indexOf(evId.replace(`${this.data.id}-`, '')) === -1) {
              delete this.$root.emitList[evId]
            }
          })
          this.eventKey = []
        },
        // 拨打电话
        tellcall(data, params) {
          const tempLink = document.createElement('a')
          tempLink.href = `tel:${data || params.tel?.value}`
          document.body.appendChild(tempLink)
          tempLink.click()
          document.body.removeChild(tempLink)
        },
        // 初始化事件
        initEvent() {
          if (!this.data.action || this.data.action.length === 0) {
            return
          }
          const handler = ({ handler: actionHandler, options: { data } = { data: '' }}, { ctx }, params, subscribe) => {
            if (subscribe.indexOf('One') > -1) {
              delete this.$root.emitList[subscribe]
            }
            switch (actionHandler) {
              case '$h_hide':
                this.componentsShow = false
                break
              case '$h_show':
                this.componentsShow = true
                break
              case '$h_tel':
                this.tellcall(data, params)
                break
              case '$h_link':
                this.parseUrl(data || params.link?.value)
                break
              case '$h_anchor':
                this.$refs.cpt.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
                break
              default:
                  // eslint-disable-next-line no-case-declarations
                const realParams = {}
                Object.keys(params).forEach(key => {
                  realParams[key] = params[key].type === 'dynamic' ? ctx[params[key].value] : params[key].value
                })
                this.$refs.cpt && this.$refs.cpt[actionHandler](realParams)
            }
          }

          this.data.action.forEach(action => {
            const { params } = action
            action.subscribe?.forEach(subscribe => {
              const paramsAll = (action.newParams && action.newParams[subscribe]) || params
              if (this.$root.emitList[subscribe]?.ctx) {
                if (action.handler === '$h_show' || this.$refs?.cpt) {
                  handler(action, this.$root.emitList[subscribe], paramsAll, subscribe)
                } else {
                  this.oneventList.push({
                    handler,
                    action,
                    triggerParams: this.$root.emitList[subscribe],
                    params: paramsAll,
                    subscribe
                  })
                }
              }
              this.$bus.$on(subscribe, (triggerParams) => {
                if (!this.$refs?.cpt && action.handler !== '$h_show') {
                  this.oneventList.push({
                    handler,
                    action,
                    triggerParams,
                    params: paramsAll,
                    subscribe
                  })
                } else {
                  handler(action, triggerParams, paramsAll, subscribe)
                }
              })
            })
          })
        },
        // 初始化动画
        initAnimation() {
          this.$refs.cpt?.$on('Animation:play', () => {
            this.$animations.forEach(animation => animation?.play())
          })
          this.$refs.cpt?.$on('Animation:pause', () => {
            this.$animations.forEach(animation => animation?.pause())
          })

          let animationCount = 0
          const { animation: animations = [] } = this.data

          this.$animations = animations.map(({ immediate = true, keyframes, iterations, ...options }, index) => {
            const animation = this.$refs.cpt?.$el.animate?.(keyframes, {
              ...options,
              iterations: +iterations
            })
            if (!immediate) {
              animation?.pause()
            }

            if (animation) {
              animation.onfinish = (ae) => {
                this.$refs.cpt.$emit(`Animation:finished:${index}`, ae)
                if (ae.target.id) {
                  this.$refs.cpt.$emit(`Animation:finished:${ae.target.id}`, ae)
                }

                animationCount++
                if (animationCount === animations.length) {
                  animationCount = 0
                  this.$refs.cpt.$emit('Animation:finished', ae)
                }
              }
            }

            return animation
          })

          this.data.$animation = this.$animations
        },
        // 监听组件挂载
        watchComponent() {
          let $component
          const vm = this
          Object.defineProperty(this.$refs, 'cpt', {
            get() {
              return $component
            },
            set(value) {
              $component = value
              if (value) {
                vm.initAnimation()
              }
            },
            enumerable: true,
            configurable: true
          })
        },
        // 解析 URL
        async parseUrl(url) {
          const parser = document.createElement('a')
          parser.href = url
          if (parser.hostname.indexOf('.didachuxing.com') === -1) {
            location.href = url
            return
          }
          const appId = BsUtil.queryString('appId')
          let search = parser.search
          const { cid, access_token } = await BsGetCid()
          const user = `cid=${cid}&access_token=${access_token}${appId ? `&appId=${appId}` : ''}`
          search = search ? `${search}&${user}` : `?${user}`
          location.href = `${parser.origin}${parser.pathname}${search}`
        }
      }
    }
    </script>
